<h2 mat-dialog-title>Position Details</h2>
<div mat-dialog-content>
    <p>Contact Organization: {{ position.contact_organization }}</p>
    <p>Packaging Type: {{ getPackageTypeDescription(position.packaging_type) }}</p>
    <p>Spot Number: {{ position.spot_number }}</p>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Close</button>
</div>
